
<template> 
  <Form :inline="true" class="form-default">
    <FormItem :label="label" :class="{'is-select': canShowEditView}"
      v-click-outside="clickOutside"
      :disabled="disabled && !hideEdit"
    >
      <div v-if="inputType !== 'dateTime'">
        <Input 
          v-if="canShowEditView"
          type="number"
          :placeholder="placeholder"
          v-model="enteredValue"
        />
        <div v-else class="field-control text-left" @click="showEditView()">
          <div v-if="defaultValue" class="form-value">
            <Ellipsis
              :text="defaultInputDisplay"
              :length="25"
            />
          </div>
          <div v-else-if="hideEdit" class="form-value d-block">-</div>
          <div v-else class="form-value d-block">Enter {{label}}</div>
        </div>
        <div class="action-edit"
          v-if="canShowEditView">
          <i class="text-grey-medium" @click="closeEditView({forceClose:true})">
            <svgicon name="icon-close" width="8" height="8" />
          </i>
          <i class="text-blue" @click="saveEnteredValue">
            <svgicon name="icon-tick-sm" width="10" height="10" />
          </i>
        </div>
      </div>
      <div class="field-control" v-else>
        <div v-if="hideEdit" class="form-value d-block">
          <span v-if="defaultValue">{{defaultInputDisplay}}</span>
          <span v-else>-</span>
        </div>
        <Date-picker
          v-else
          @focus="showEditView"
          :value="defaultValue"
          v-model="enteredValue"
          type="datetime"
          placeholder="Enter day & time"
          format="dd-MM-yyyy hh:mmA"
          :clearable="false"
          :disabled="disabled"
          :pickerOptions="getPickerOptions"
          popper-class="disabled-action"
        >
        </Date-picker>
        <span class="action-edit"
          v-if="canShowEditView">
          <i class="text-grey-medium" @click="closeEditView({forceClose:true})">
            <svgicon name="icon-close" width="8" height="8" />
          </i>
          <i class="text-blue" @click="saveEnteredValue">
            <svgicon name="icon-tick-sm" width="10" height="10" />
          </i>
        </span>
      </div>
    </FormItem>
  </Form>
</template>

<script>
import { mapGetters } from 'vuex';
import { isObject } from 'lodash';
import {
  formatLastKnownTime
} from '@/lib/Date';

export default {
  data() {
    return {
      enteredValue: null,
      showActions: false,
    };
  },
  props: [
    'defaultValue',
    'label',
    'placeholder',
    'inputType',
    'hideEdit',
    'disabled',
    'baseMinDate',
    'errorOnSave',
    'isSavingData',
  ],
  mounted() {
    if(this.inputType === 'dateTime') {
      this.enteredValue = this.defaultValue;
    }
  },
  computed: {
    defaultInputDisplay() {
      return this.inputType === 'dateTime' ?
        formatLastKnownTime(this.defaultValue) : parseFloat(this.defaultValue).toString();
    },
    canShowEditView() {
      return !this.hideEdit && (this.showActions || this.isSavingData);
    },
    getPickerOptions() {
      const baseDate = this.baseMinDate;
      const currentDate = this.enteredValue;

      const date1 = new Date(this.enteredValue); 
      date1.setHours(0, 0, 0, 0);
      const date2 = new Date(baseDate); 
      date2.setHours(0, 0, 0, 0);
 
      if(baseDate) {
        const mindate = new Date(this.$moment(baseDate));
        const baseTime = mindate.toLocaleTimeString();
        return {
          disabledDate(time) {
            if(mindate) {
              return time.getTime() < new Date(mindate).getTime() - 8.64e7;
            }
          },
          selectableRange: (date1.getTime() === date2.getTime()) ? `${baseTime} - 23:59:59`: '00:00:00 - 23:59:59',
        };
      }
    },
  },
  methods: {
    showEditView() {
      this.showActions = true;
      this.enteredValue = this.errorOnSave ? this.enteredValue : this.defaultValue;
    },
    closeEditView({value,forceClose}) {
      if(!this.errorOnSave || forceClose) {
        this.showActions = false;
        this.enteredValue = value || this.defaultValue; 
      }
    },
    clickOutside() {
      this.showActions = false;
      this.enteredValue = this.defaultValue;
    },
    async saveEnteredValue() {
      try {
        if(this.enteredValue) {
          this.$emit('changeValue',this.enteredValue);
        } else {
          this.$error({message: 'Please change the value to save!'})
        }
        this.closeEditView({value:this.enteredValue});
      } catch (error) {
        this.$error({message: this.$getErr('GENERAL_ERR')})
      }
    },
  },
  watch: {
    errorOnSave(newVal) {
      if(newVal) {
        this.showActions = true;
      } else {
        this.showActions = false;
      }
    }
  }
};
</script>